import { useEffect } from 'react';

/**
 * @param title - The title to set for the document.
 * @param enabled - A boolean or a function that returns a boolean. If the function returns `false`,
 * the title will not be set. If the function returns `true`, the title will be set.
 * If the function is not provided, the title will be set.
 *
 * @description Use this hook to set the document title in client components. Do not use <title> tag since
 * using `generateMetadata` and `<title>` tags might cause double title tags in `<head>` tag.
 */
export function useSetDocumentTitle(title: string, enabled: boolean | (() => boolean) = true) {
  // compute the enabledValue outside of useEffect to avoid re-rendering
  // if enabled is not a referentially stable function
  const enabledValue = typeof enabled === 'function' ? enabled() : (enabled ?? true); // fallback to `true`

  useEffect(() => {
    if (enabledValue) {
      document.title = title;
    }
  }, [title, enabledValue]);
}
